import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// import { CustomFormsModule } from 'ngx-custom-validators';
// import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

/* Local components */
import { SeniorComponent } from './senior.component';
import { SeniorHomeComponent } from './components/home/senior-home.component';
import { SeniorAttachedComponent } from './components/attached/senior-attached.component';
import { SeniorRankingComponent } from './components/ranking/list/senior-ranking.component';
import { SeniorRankingClassifComponent } from './components/ranking/classification/senior-ranking-classif.component';

/* Routes */
import { SeniorRoutingModule } from './senior-routing.module';

/* Interceptor */
import { Interceptor } from 'src/app/core/interceptors/http-request-interceptor';
import { ThemeModule } from 'src/app/@theme/theme.module';

@NgModule({
    declarations: [
        SeniorComponent,
        SeniorHomeComponent,
        SeniorAttachedComponent,
        SeniorRankingComponent,
        SeniorRankingClassifComponent,
    ],
    imports: [CommonModule, RouterModule, SeniorRoutingModule, Interceptor, ThemeModule],
})
export class SeniorModule {}
